let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("lyGo1")]).then(() => parcelRequire('9bkHc'));